import { useCurrentUser } from '../../_services/hooks/user';
import { useCustomer } from '../../_services';
import { isAONorConvertingtoAON } from '../../utils';
import { HUBOnboard } from './HUB/HUBOnboard';
import { AONOnboard } from './AON/AONOnboard';

export const Onboard = () => {
  const { customerId } = useCurrentUser();
  const { customer } = useCustomer(customerId);

  if (!customer || !customerId) return <></>;

  if (isAONorConvertingtoAON(customer)) {
    return <AONOnboard customerId={customerId} />;
  } else {
    return <HUBOnboard />;
  }
};
